import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, withRouter } from "react-router-dom";

import UserRoute from "./UserRoute";

import NewContextWizard from "../modules/wizard/NewContextWizard";
import PageNotFound from "../errors/PageNotFound";

/**
 * Wizards: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Switch that routes all wizard pages accordingly
 * to their respective UserRoutes
 *
 * @param {*} props
 */
const Wizards = props => (
  <Switch>
    <UserRoute
      location={props.location}
      path="/create/context"
      component={NewContextWizard}
    />
    <Route location={props.location} component={PageNotFound} />
  </Switch>
);

Wizards.propTypes = {
  /**
   * location: {}
   * Location object as provided by withRouter
   */
  location: PropTypes.shape({}).isRequired
};

export default withRouter(Wizards);



// WEBPACK FOOTER //
// ./src/routes/Wizards.js